import React, { useEffect } from "react";

import { useLocation, useParams } from "react-router-dom";

import { TradeProposalId } from "@fartherfinance/frontend/api/Investment/types";

import AdvisorContainer from "../AdvisorContainer";
import AdvisorContentContainer from "../AdvisorContentContainer";
import FinOpsLayout from "@src/multiCustodian/components/Advisor/FinanicalOperations/FinOpsLayout";
import ProposalDetails from "@src/multiCustodian/components/Advisor/FinanicalOperations/Proposals/ProposalDetails";

interface Params {
  proposalId: TradeProposalId;
}

type LocationState = { proposalIds?: TradeProposalId[] } | undefined;

const TradeProposal: React.FC = () => {
  const { proposalId } = useParams<Params>();
  const { pathname, state } = useLocation<LocationState>();

  // scroll to the top of the page when the route changes
  useEffect(() => {
    document
      .getElementById("proposal-details-header")
      ?.scrollIntoView({ behavior: "smooth", block: "end" }); // block tries to put this element at the bottom of the page
  }, [pathname]);

  const proposalIdx = state?.proposalIds?.findIndex((x) => x === proposalId);
  const nextProposalId =
    proposalIdx !== undefined
      ? state?.proposalIds?.[proposalIdx + 1]
      : undefined;

  return (
    <AdvisorContainer>
      <AdvisorContentContainer heroTitle={"Financial Operations"}>
        <FinOpsLayout>
          <ProposalDetails
            tradeProposalId={proposalId}
            nextProposalId={nextProposalId}
          />
        </FinOpsLayout>
      </AdvisorContentContainer>
    </AdvisorContainer>
  );
};

export default TradeProposal;
